import { relationRank } from './helpers';

// The order the people of one household print in.
//
// By default it is the order a family is READ in — head, wife, son, his wife,
// their children, the daughters, then the elders (relationRank). That is right
// most of the time and wrong often enough: an elder brother after a younger
// one, a nephew living with them, a second household under one roof. So a
// member may be MOVED, and `Evt_Guests.FamilyOrder` then wins for that family.
//
// A family is either hand-ordered or it is not: as soon as one member carries a
// FamilyOrder, every member is placed by it (the ones without fall to the end,
// still in relation order). Pure, so the moving is tested without a browser.
const num = (v) => (v === null || v === undefined || v === '' ? null : Number(v));
const txt = (v) => String(v || '').trim().toLowerCase();

export const hasHandOrder = (members) => (members || []).some(m => num(m.FamilyOrder) !== null);

// → the members of one household, in the order they should print.
export function sortFamilyMembers(members) {
  const list = [...(members || [])];
  if (!hasHandOrder(list)) {
    return list.sort((a, b) => relationRank(a.Relation) - relationRank(b.Relation)
      || txt(a.GuestName).localeCompare(txt(b.GuestName)));
  }
  return list.sort((a, b) => {
    const ao = num(a.FamilyOrder); const bo = num(b.FamilyOrder);
    if (ao !== null && bo !== null) return ao - bo;
    if (ao !== null) return -1;          // a hand-placed member comes first
    if (bo !== null) return 1;
    return relationRank(a.Relation) - relationRank(b.Relation)
      || txt(a.GuestName).localeCompare(txt(b.GuestName));
  });
}

// Moving one member up or down. Returns the numbers to SAVE — every member of
// the household, because an order only means something as a whole — or null
// when the move would run off the end.
//   members  the household's members (any order; they are sorted here)
//   guestId  the one being moved
//   dir      -1 up, +1 down
export function moveMember(members, guestId, dir) {
  const list = sortFamilyMembers(members);
  const i = list.findIndex(m => String(m.GuestId) === String(guestId));
  const j = i + (dir < 0 ? -1 : 1);
  if (i < 0 || j < 0 || j >= list.length) return null;
  const moved = [...list];
  [moved[i], moved[j]] = [moved[j], moved[i]];
  // 10, 20, 30 … so a later insertion can be slipped between two of them.
  return moved.map((m, k) => ({ GuestId: m.GuestId, FamilyOrder: (k + 1) * 10 }));
}
